module.exports = __webpack_public_path__ + "img/image-027.52e5c5b7.png";